export default {"src":"__ASTRO_ASSET_IMAGE__C30ANb2r__","width":366,"height":222,"format":"png"}